module.exports = "<!-- <mat-dialog-content> -->\r\n    <div class=\"modal-header\">\r\n        <h3 class=\"modal-title\">{{ title }}</h3>\r\n    </div>\r\n    <div class=\"modal-body\">\r\n        <div [innerHTML]=\"message\"></div>\r\n    </div>\r\n    <div class=\"modal-footer\">\r\n        <button class=\"btn btn-primary\">{{ okButton }}</button>\r\n    </div>\r\n<!-- </mat-dialog-content> -->\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/dialogs/alert-dialog/alert-dialog.component.html
// module id = ./src/app/shared/dialogs/alert-dialog/alert-dialog.component.html
// module chunks = main